<!-- 图表底部时间范围切换tab -->
<template>
  <div class="period-switch-box">
    <!-- tab -->
    <div class="tab-list">
      <div
        v-for="(item, index) in showTabList"
        :key="index"
        :class="index === curIndex ? 'cur-tab-item' : 'tab-item'"
        @click="clickTab(index,item)">
        <div>{{item.label}}</div>
      </div>
      <!-- 更多 -->
      <div :class="curIndex >= 4 ? 'cur-tab-item' : 'tab-item'" @click="clickMore">
        <div>{{moreTab.label}}</div>
        <img :src="icon" class="more-tab-icon"/>
      </div>
    </div>
    <!-- 选择弹窗 -->
    <div v-if="showPopup" class="period-popup">
      <div class="popup-container">
        <div v-for="(item, index) in moreTabList" :key="index"
          @click="clickMoreItem(index, item)"
          :class="index + 4 === curIndex ? 'cur-more-item' : 'more-item'"
        >{{item.label}}</div>
        <div @click="cancelPopup" class="cancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/configs/default';
import tool from '@/utils/tool';

export default {
  name: 'period-switch-tab',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      icon: 'https://j5.dfcfw.com/sc/image/202109/20210927015147.png',
      tabList: [...config.chartPeriodList],
      curIndex: 3, // 当前选中tabIndex
      showPopup: false, // 弹窗展示状态
    };
  },

  computed: {
    showTabList() {
      return this.tabList?.slice(0, 4) || [];
    },
    moreTab() {
      const label = this.curIndex >= 4 ? this.tabList[this.curIndex]?.label : '更多';
      // label = this.tabList[this.curIndex]?.value === 'ln' ? `${label}(${this.establishDayText})`
      //   : label;
      return {
        label,
        value: this.curIndex >= 4 ? this.tabList[this.curIndex]?.value : 'more',
      };
    },
    establishDayText() {
      const days = tool.getDaysToNow(this.basicInfo?.establishDate);
      const year = Math.floor(days / 365);
      const day = days % 365;
      return year > 0 ? `${year}年${day}天` : `${day}天`;
    },
    moreTabList() {
      const moreList = this.tabList?.slice(4) || [];
      return moreList.map((item) => ({
        ...item,
        label: item.value === 'ln' ? `${item.label}(${this.establishDayText})`
          : item.label,
      })) || [];
    },
  },

  methods: {
    // 切换tab
    clickTab(index, item) {
      this.curIndex = index;
      this.$emit('periodChange', { index, ...item });
    },
    // 点击更多
    clickMore() {
      this.showPopup = true;
    },
    cancelPopup() {
      this.showPopup = false;
    },
    clickMoreItem(index, item) {
      this.curIndex = index + 4;
      this.showPopup = false;
      this.$emit('periodChange', { index: index + 4, ...item });
    },
  },
};
</script>

<style lang="less" scoped>
.period-switch-box {
  width: 100%;
}
.tab-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.cur-tab-item {
  flex: 1;
  height: 88px;
  background-color: #ffffff;
  font-size: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #000000;
}
.tab-item {
  flex: 1;
  height: 88px;
  background-color: #F8F8F8;
  font-size: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #666666;
}
.more-tab-icon {
  width: 24px;
  height: 24px;
}
.period-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.popup-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
}
.more-item {
  text-align: center;
  line-height: 100px;
  font-size: 32px;
  background-color: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  color: #000000;
}
.cur-more-item {
  text-align: center;
  line-height: 100px;
  font-size: 32px;
  background-color: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  color: #ff4400;
}
.cancel {
  margin-top: 10px;
  background-color: #ffffff;
  text-align: center;
  line-height: 100px;
  font-size: 32px;
}
</style>
